<template>
	<div id="successWrapper">
		<div class="flex items-center justify-center h-screen">
			<span class="successBox">{{ systemStore.success.text }} <span class="successIcon"><span class="icon-check"></span></span></span>
		</div>
	</div>
</template>

<script setup>
import {onMounted} from "vue";
import { useSystemStore } from "@/stores/system/SystemStore";
import sleep from "@/utilities/system/helpers/Sleeper";

const systemStore = useSystemStore();

onMounted(async () => {
	await sleep(2000);
	systemStore.success.show = false;
})
</script>

<style lang="scss">

</style>
